module.exports = __webpack_public_path__ + "img/ai-gift.17b141cf.svg";